import React from 'react'
import './CashBook.css'
import { Download } from 'lucide-react'

const CashBook = () => {
  return (
    <>
      <div className="cashBook-container">
        <h1 className="cashBook-heading">Cash Book</h1>

        {/* Overview Form Section */}
        <section className="cashBook-top">
          <form action="" className="cashBook-form">
            <div className="cashBook-form-section">
              <div className="cashBook-form-input-fields">
                <label>Select Branch</label>
                <select name="" id="">
                  <option value="">Select Branch</option>
                </select>
              </div>
              <div className="cashBook-form-input-fields">
                <label>Select Date</label>
                <input type="date" />
              </div>
              <div className="cashBook-form-input-fields">
                <label>Select Bank Ledger</label>
                <select name="" id="">
                  <option value="">Select Back Ledger</option>
                </select>
              </div>
            </div>
            <div className="cashBook-form-submit-btn">
              <button>Get Records</button>
            </div>
          </form>
        </section>

        {/* pdf download buttons */}
        <div className="cashBook-pdf-download-btns">
          <button>
            <Download size={15}/> Print Cashbook
          </button>
          <button>
            <Download size={15}/> Print Bankbook
          </button>
          <button>
            <Download size={15}/> Print Cashbook & Bankbook
          </button>
        </div>

        {/* Overview Report Section */}
        <section className="cashBook-report">
          <div className="cashBook-report-container">
            <p className="cashBook-report-heading">Cash Records</p>
            <div className="cashBook-report-table">
              <div className="cashBook-report-table-div">
                <div className="cashBook-report-debit-table">
                  <p>Debit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>DR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Debit</td>
                    </tr>
                  </table>
                </div>
                <div className="cashBook-report-credit-table">
                  <p>Credit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>CR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Credit</td>
                    </tr>
                  </table>
                </div>
              </div>
              <p style={{ textAlign: "center", fontWeight: 600 }}>
                Closing Balance NaN ()
              </p>
            </div>
          </div>
          <div className="cashBook-report-container">
            <p className="cashBook-report-heading">Bank Records</p>
            <div className="cashBook-report-table">
              <div className="cashBook-report-table-div">
                <div className="cashBook-report-debit-table">
                  <p>Debit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>DR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Debit</td>
                    </tr>
                  </table>
                </div>
                <div className="cashBook-report-credit-table">
                  <p>Credit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>CR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Credit</td>
                    </tr>
                  </table>
                </div>
              </div>
                <p style={{ textAlign: "center", fontWeight: 600 }}>
                  Closing Balance NaN ()
                </p>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default CashBook
